export enum BranchEnum {
  HEALTH = 'health',
  DENTAL = 'dental',
  PETS = 'pets',
  TRAVEL = 'travel',
  LIFE = 'life',
  HOSPITALIZATION = 'hospitalization',
  ACCIDENTS = 'accidents',
  FOREIGN_HEALTH = 'health-foreign',
  HOME = 'hogar'
}

export default BranchEnum
